<template>
  <header class="header position-fixed header-filled rounded-0 shadow-none">
    <div class="row">
      <div class="col-auto"></div>
      <div class="col">
        <div class="logo-small">
          <img src="pic/Logo.png" alt="" class="shadow-none" />
          <h5>Geo<b>OPS</b></h5>
        </div>
      </div>
      <div class="col-auto">
        <a href="/Notifications" target="_self" class="btn btn-light btn-44">
          <i class="bi bi-bell"></i>
          <span v-if="unreadCount > 0" class="count-indicator">{{
            unreadCount
          }}</span>
        </a>
        <a class="ms-2">
          <img
            :src="profilePicSrc"
            @error="handleImageError"
            alt=""
            class="shadow-none btn btn-light btn-44"
          />
        </a>
        <a @click="userLogout" class="btn btn-light btn-44 ms-2">
          <i class="bi bi-box-arrow-in-right"></i>
        </a>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      isLoading: false,
      error: null,
      thisUser: null,
      imageLoadError: false,
    };
  },
  computed: {
    unreadCount() {
      return this.$store.getters.getUnreadCount;
    },
    isLoggedIn() {
      return this.$store.getters.isAuthenticated;
    },
    userProfilePicLink() {
      return (
        "https://dcimg.telecom.pt/fotosDirectorio/" +
        this.$store.getters.getUserDetailList.usr_mecano +
        ".jpg"
      );
    },
    profilePicSrc() {
      if (this.imageLoadError) {
        return "pic/user.png";
      }
      return this.userProfilePicLink;
    },
  },
  methods: {
    async userLogout() {
      this.isLoading = true;

      try {
        await this.$store.dispatch("logout");
      } catch (err) {
        this.error = err.message || "Failed to logout, try later.";
      } finally {
        this.$router.replace("/loginOPS");
      }
      this.isLoading = false;
    },
    handleImageError() {
      this.imageLoadError = true;
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
}

.background-container {
  background-image: url("../../../public/pic/Logo.png");
  background-color: white;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  min-height: 100%;
  height: 30vh;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: start;
}

.top-left,
.top-right {
  padding: 20px;
  color: black;
  border-radius: 5px;
}

.top-left {
  align-self: flex-start;
}

.top-right {
  align-self: flex-start;
}

.count-indicator {
  color: whitesmoke;
  border-color: red;
  border-left: 5%;
  font-size: 10px;
  font-weight: bold;
}
</style>
